export default "__VITE_ASSET__BLTcuMlE__"